import { Component } from '@angular/core';

@Component({
    selector: 'link',
    templateUrl: './link.component.html',
})
export class LinkComponent {}
